import React from 'react';
import { inject, observer } from 'mobx-react';
import { VisibleOnlyAuthenticated } from '../helpers';
var TheUserName = inject('userStore')(observer(function (_ref) {
  var userStore = _ref.userStore;
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-cog",
    style: {
      paddingRight: '4px'
    }
  }), " ", userStore.user.name);
}));
export var UserName = VisibleOnlyAuthenticated(TheUserName);